import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultDescription,
  defaultGastronomyOtherFacilities,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentGastronomySellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    totalFloorSpace: validationRules.totalFloorSpace,
    mainFloorSpace: validationRules.mainFloorSpace,
    auxiliaryArea: validationRules.auxiliaryArea,
    buildingType: validationRules.buildingType,
    price: usePurchasePriceOnRequestCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: defaultGastronomyOtherFacilities,

  construction: defaultConstruction,
  connections: defaultConnections,
  objectNumbers: defaultObjectNumbers,
  apiSearchData: defaultApiSearchData,
}
